export const formatedDate = (date, withTime = false) => {
  let formatDate = new Date(date);
  return withTime? formatDate.toLocaleDateString("pt-br") + ' ' + formatDate.toLocaleTimeString() : formatDate.toLocaleDateString("pt-br");
}